var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{ref:"input",class:{'text-muted': _vm.isDisabled()},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.showModal()}}},[_vm._v(" "+_vm._s(_vm.summary)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }